import { useCallback } from 'react'
import { useCenterStore } from '@caradasstore/CenterStore'
import { useEntitlementStore } from '@caradasstore/EntitlementStore'
import { useUserStore } from '@caradasstore/UserStore'

import { canUseModule } from '../data/entitlements'

/**
 * `canUse(module)` for the active center's plan (CAR-3710) — the in-page counterpart of the
 * sidebar filter and the route guard. Use it on shortcuts and buttons that lead into another
 * section (Home tiles, "New Quote" on VIN Search, the QuickBooks settings tab), so a plan that
 * lacks the section does not offer a dead end.
 *
 * Same rules as everywhere else: admins always may, an admin-switched module (AI Report) needs
 * its center switch on, a shortcut shows only once its module is
 * known to be allowed for this user and center, and hiding is a courtesy - the API refuses regardless
 * (EntitlementEnforcementFilter).
 */
export const useModuleAccess = () => {
  const user = useUserStore((store) => store.currentUser)
  const ccId = useCenterStore((store) => store.ccId)
  const centerDetail = useCenterStore((store) => store.centerDetail)
  const entitlements = useEntitlementStore()

  return useCallback((module) => canUseModule({ user, entitlements, ccId, module, centerDetail }), [user, entitlements, ccId, centerDetail])
}
